<template>
  <div>
    <!------------ toast / snackbar ------------------------------>
    <v-snackbar
      absolute
      right
      top
      class="mr-n2"
      v-model="snackbar"
      :timeout="timeout"
      color="primary"
      outlined
    >
      <div class="d-flex justify-space-between">
        <div class="d-flex align-center">
          <v-icon color="primary" size="22"
            >mdi-checkbox-multiple-marked-circle-outline</v-icon
          >
          <span class="mt-n1 ml-5 text_style">Update successfully</span>
        </div>
        <div>
          <v-icon color="primary" size="22" @click="snackbarClose()"
            >mdi-close-circle-outline</v-icon
          >
        </div>
      </div>
    </v-snackbar>
    <v-snackbar
      absolute
      right
      top
      class="mr-n2"
      v-model="Deletesnackbar"
      :timeout="timeout"
      color="error"
      outlined
    >
      <div class="d-flex justify-space-between">
        <div class="d-flex align-center">
          <v-icon color="error" size="22">mdi-alert-circle-outline</v-icon>
          <span class="mt-n1 ml-5 text_style">Delete successfully</span>
        </div>
        <div>
          <v-icon color="error" size="22" @click="snackbarClose()"
            >mdi-close-circle-outline</v-icon
          >
        </div>
      </div>
    </v-snackbar>
    <!------------ toast / snackbar ------------------------------>
    <div>
      <!------------------section one------------------------>
      <v-row class="d-flex justify-space-between" flat>
        <v-col md="6" sm="6">
          <h1 class="heading-1">Team</h1>
        </v-col>
        <!--------------------------- add team --------------------------------------->
        <v-col md="6" sm="6">
          <v-card flat class="d-flex justify-end mt-2">
            <!-- <v-btn color="primary">Add new</v-btn> -->
            <v-btn
              color="primary"
              dark
              v-if="Permission.Add"
              class="text_style px-7"
              depressed
              @click="openadddialog()"
            >
              Add new
            </v-btn>
            <v-dialog
              v-model="add_dialog"
              v-if="add_dialog"
              persistent
              max-width="400"
            >
              <v-card>
                <add-team-component
                  :add_dialog="add_dialog"
                  @close="closeDialog"
                  @update="close"
                />
              </v-card>
            </v-dialog>
          </v-card>
        </v-col>
      </v-row>
      <!------------------section two------------------------>
      <div class="my-3">
        <v-row class="mt-6">
          <v-col cols="12" md="5" sm="6">
            <v-card flat>
              <v-text-field
                dense
                outlined
                prepend-inner-icon="mdi-magnify"
                label="Search..."
                v-model="search"
                hide-details
                single-line
              >
              </v-text-field>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <!------------------section three ( data table )------------------------>

      <div>
        <v-card class="mt-6" outlined>
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="displayedItemsPerPage"
            :page.sync="page"
            :loading="tableLoader"
            hide-default-footer
            loading-text="Loading... Please wait"
          >
            <template v-slot:[`item.index`]="{ index }">
              <span class="index_h1_text_style">
                <b> {{ index + displayedItemsPerPage * (page - 1) + 1 }} </b>
              </span>
            </template>
            <template v-slot:[`item.FirstName`]="{ item }">
              <div style="display: flex; align-items: center" class="pa-4 ps-0">
                <v-avatar v-if="typeof item.ProfileImage == 'string'">
                  <img :src="imageUrl(item.ProfileImage)" alt="John" />
                </v-avatar>
                <v-avatar v-else>
                  <v-icon>mdi-account-off-outline</v-icon>
                </v-avatar>
                <div>
                  <p class="mb-0 mx-3" v-if="item.IsRegistered">
                    <b class="index_h1_text_style">
                      {{ item.FirstName }} {{ item.LastName }}</b
                    >
                  </p>
                  <p class="mb-0 mx-3" v-else>
                    <b class="index_h1_text_style">Pending Registration</b>
                  </p>
                  <p class="mb-0 mx-3 index_span_text_style">
                    {{ item.Email }}
                  </p>
                </div>
              </div>
            </template>
            <template v-slot:[`item.Role`]="{ item }">
              <span class="index_span_2_style"> {{ item.Role }} </span>
            </template>
            <template v-slot:[`item.Status`]="{ item }">
              <v-chip
                class="ma-2"
                outlined
                color="#ccc"
                text-color="#ccc"
                v-if="!item.IsRegistered"
              >
                Un-registerd
              </v-chip>
              <v-chip
                class="ma-2"
                outlined
                color="red"
                text-color="red"
                v-if="item.IsRegistered && item.Status === 3"
              >
                In-active
              </v-chip>
              <v-chip
                class="ma-2"
                outlined
                color="green"
                text-color="green"
                v-if="item.IsRegistered && item.Status === 2"
              >
                Active
              </v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-menu
                transition="scroll-y-transition"
                offset-y
                color="transparent"
                v-if="item.Role != 'Master'"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="#A1A1A6" v-bind="attrs" v-on="on">
                    mdi-dots-horizontal
                  </v-icon>
                </template>
                <v-card style="border-radius: 1vw" flat class="list-styling">
                  <v-list
                    class="px-3 pt-5"
                    color="transparent"
                    v-if="item.IsRegistered"
                  >
                    <router-link
                      to="/team/profile"
                      style="text-decoration: none"
                    >
                      <v-btn
                        depressed
                        color="transparent"
                        block
                        class="d-flex justify-start"
                        @click="ViewProfile(item)"
                      >
                        <v-icon color="#646464">mdi-account-circle</v-icon>
                        <span class="ml-4 text_style action_dialog"
                          >See Profile</span
                        >
                      </v-btn>
                    </router-link>
                  </v-list>
                  <v-list
                    class="px-3 pt-1"
                    color="transparent"
                    v-if="Permission.Edit"
                  >
                    <!-- <v-btn
                      depressed
                      color="transparent"
                      block
                      class="d-flex justify-start"
                      @click="EditItem(item)"
                    >
                      <v-icon color="#646464">mdi-pencil</v-icon>
                      <span class="ml-4">Edit</span>
                    </v-btn> -->
                    <v-btn
                      depressed
                      color="transparent"
                      block
                      class="d-flex justify-start"
                      @click="SetModel(item)"
                      v-if="Permission.Edit && item.IsRegistered"
                    >
                      <v-icon color="#646464">mdi-pencil</v-icon>
                      <span class="ml-4 text_style action_dialog">Edit</span>
                    </v-btn>
                  </v-list>
                  <v-list
                    class="px-3 pt-1"
                    color="transparent"
                    v-if="!item.IsRegistered"
                  >
                    <v-btn
                      depressed
                      color="transparent"
                      block
                      class="d-flex justify-start list-styling"
                      @click="SendMailAgain(item)"
                      v-if="Permission.Delete"
                    >
                      <v-icon color="#646464">mdi-email</v-icon>
                      <span class="ml-4 text_style action_dialog list-styling"
                        >Send Mail again</span
                      >
                    </v-btn>
                  </v-list>
                  <v-list
                    class="px-3 pt-1 list-styling"
                    color="transparent"
                    v-if="Permission.Delete"
                  >
                    <v-btn
                      depressed
                      color="transparent"
                      block
                      class="d-flex justify-start list-styling"
                      @click="ConfirmDelete(item)"
                      v-if="Permission.Delete"
                    >
                      <v-icon color="#646464">mdi-delete</v-icon>
                      <span class="ml-4 text_style action_dialog list-styling"
                        >Delete</span
                      >
                    </v-btn>
                  </v-list>
                </v-card>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
        <v-card flat class="my-9 d-flex justify-end align-center">
          <span class="text_transform pa-0 ma-0">Per page : </span>
          <v-card flat width="100" class="mx-5">
            <v-select
              :items="ItemsPerPageItems"
              label="Items per page"
              v-model="itemsPerPage"
              @change="fetchData()"
            ></v-select>
          </v-card>
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="5"
            @input="fetchData"
          ></v-pagination
        ></v-card>
      </div>
    </div>
    <!-----------start-team edit dialog-------------------------->
    <v-dialog
      v-model="editdialog"
      v-if="EditTeamModel != null"
      persistent
      max-width="600"
    >
      <v-card>
        <div class="mx-5 py-5 d-flex justify-space-between">
          <span class="heading-2"> <b> Edit Team Member</b></span>
          <v-icon @click="close">mdi-close</v-icon>
        </div>
        <div>
          <edit-team-component :EditTeamModel="EditTeamModel" @close="close" />
        </div>
      </v-card>
    </v-dialog>
    <!-----------end-team edit dialog-------------------------->
    <!-----------start-team delete dialog-------------------------->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="red darken-1" text @click="Delete"> Confirm </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-----------end-team delete dialog-------------------------->
  </div>
</template>

<script>
import AddTeamComponent from "../../components/Team/AddTeam.component.vue";
import EditTeamComponent from "../../components/Team/EditTeam.component.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    AddTeamComponent,
    EditTeamComponent,
  },

  // props: ["loader"],
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      activeStatusLoader: false,
      snackbar: false,
      Deletesnackbar: false,
      timeout: 1500,
      editdialog: false,
      tableLoader: false, // data-table true or false
      SeeProfileDialog: false,
      btnloader: false,
      add_dialog: false,
      dialog: false,
      filter: "",
      deleteId: 0,
      search: "",
      searchTimer: 0,
      EditTeamModel: {},
      Permission: {},
      filterItem: [
        {
          text: "All users",
        },
        {
          text: "Registered user",
        },
        {
          text: "Un-Registered user",
        },
      ],
      items: [],
      headers: [
        { text: "#", value: "index", sortable: false },
        { text: "Name", value: "FirstName" },
        { text: "Role", value: "Role" },
        { text: "Status", value: "Status" },
        { text: "", value: "actions", sortable: false },
      ],
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
    };
  },
  computed: {
    ...mapGetters(["GetTeamMembers", "GetUserRolePermissions"]),
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.items.length
        : this.itemsPerPage;
    },
  },
  mounted() {
    this.tableLoader = true;
    this.fetchData().then(() => {
      this.items = this.GetTeamMembers;
      this.tableLoader = false;
    });
    this.Permission = this.GetUserRolePermissions.RolePermissions.find(
      (x) => x.Module === "Team"
    );
  },
  methods: {
    ConfirmDelete(item) {
      this.deleteId = item.Id;
      this.dialog = true;
    },
    SendMailAgain(item) {
      this.$store.dispatch("SendMailAgain", item.Id).then((res) => {
        if (res.data.Status) {
          this.$swal.fire({
            icon: "success",
            title: res.data.Message,
            confirmButtonColor: "#3085d6",
            showConfirmButton: true,
          });
        }
      });
    },
    Delete() {
      if (this.deleteId > 0) {
        this.$store.dispatch("DeleteTeamMember", this.deleteId).then(() => {
          this.dialog = false;
          this.deleteId = 0;
          this.fetchData().then(() => {
            this.items = this.GetTeamMembers;
          });
        });
      }
    },
    // Search() {
    //   if (this.search != "") {
    //     this.items = [];
    //     this.items = this.GetTeamMembers.filter((s) => {
    //       if (s.Email.toLowerCase().includes(this.search.toLowerCase())) {
    //         if (this.filter == "") {
    //           return s;
    //         } else {
    //           if (this.filter == "Registered user") {
    //             if (s.IsRegistered) {
    //               return s;
    //             }
    //           } else if (this.filter == "Un-Registered user") {
    //             if (!s.IsRegistered) {
    //               return s;
    //             }
    //           } else {
    //             return s;
    //           }
    //         }
    //       }
    //     });
    //   } else {
    //     this.items = this.GetTeamMembers;
    //     if (this.filter == "Registered user") {
    //       this.items = this.items.filter((s) => s.IsRegistered);
    //     } else if (this.filter == "Un-Registered user") {
    //       this.items = this.items.filter((s) => !s.IsRegistered);
    //     } else {
    //       this.items = this.GetTeamMembers;
    //     }
    //   }
    // },
    ViewProfile(item) {
      this.$store.dispatch("SetViewTeamMember", item);
    },
    SetModel(item) {
      this.editdialog = true;

      this.EditTeamModel = item;
    },
    async close(cancel) {
      this.editdialog = false;
      if (!cancel) {
        this.items = [];
        this.tableLoader = true;
        this.fetchData().then(() => {
          this.items = this.GetTeamMembers;
          this.tableLoader = false;
          this.add_dialog = false;
          this.snackbar = true;
          this.EditTeamModel = null;
        });
      }
    },
    closeDialog() {
      this.add_dialog = false;
    },
    DdialogClose() {
      this.dialog = false;
      this.Deletesnackbar = true;
    },
    snackbarClose() {
      // this.snackbar = false;
      this.Deletesnackbar = false;
    },
    openadddialog() {
      this.add_dialog = true;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.add_dialog = false;
        this.editdialog = false;
        this.btnloader = false;
        this.snackbar = true;
      }, 2000);
    },
    goBack() {
      this.isHidden = false;
    },
    imageUrl(data) {
      // return data ? process.env.VUE_APP_IMG_URL + data : "";
      return data ? data : "";
    },
    async fetchData() {
      var obj = {
        page: this.search ? 1 : this.page,
        pageSize: this.itemsPerPage,
        search: this.search,
      };
      this.tableLoader = true;
      await this.$store.dispatch("GetTeamMembers", obj).then((res) => {
        this.items = this.GetTeamMembers;
        if (this.itemsPerPage != "All") {
          this.pageCount = Math.ceil(res.totalRecords / this.itemsPerPage);
        } else {
          this.pageCount = 1;
        }
        this.tableLoader = false;
        if (this.pageCount > 1) {
          this.page = res.page;
        } else {
          this.page = 1;
        }
      });
    },
  },
  watch: {
    search() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.fetchData();
      }, 700);
    },
  },
};
</script>

<style scoped>
.AddTeamFotterBtnMobile {
  display: none;
}
.list-styling {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.25px;
  color: rgba(34, 34, 34, 0.87);
}
@media screen and (max-width: 430px) {
  .AddTeamFotterBtnMobile {
    display: block;
  }
  .AddTeamFotterBtnDestop {
    display: none;
  }
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
</style>
